'use client';
import {useSyncExternalStore} from 'react';
import type {RegisterInterestOpenOptions} from './register-interest-controller';

let context: RegisterInterestOpenOptions | undefined;
const listeners = new Set<() => void>();

function emit(): void {
  listeners.forEach(listener => {
    listener();
  });
}

export function setPageRegisterInterestContext(next: RegisterInterestOpenOptions): () => void {
  context = next;
  emit();
  return () => {
    if (context === next) {
      context = undefined;
      emit();
    }
  };
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

// Returns the stored reference, not a fresh object — `useSyncExternalStore`
// re-renders on every snapshot identity change, so building one here would loop.
function getSnapshot(): RegisterInterestOpenOptions | undefined {
  return context;
}

function getServerSnapshot(): RegisterInterestOpenOptions | undefined {
  return undefined;
}

export function usePageRegisterInterestContext(): RegisterInterestOpenOptions | undefined {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
